import { storeToRefs } from 'pinia'
import { ref } from '@vue/composition-api'
import useUserStore from '@/store/user'
import EmpresaService from '@/services/modules/EmpresaService'

export default function useEmpresaData() {
  const { empresaId } = storeToRefs(useUserStore())
  const empresaNome = ref('')

  async function getEmpresaNome() {
    if (empresaNome.value) return
    const empresa = await EmpresaService.getEmpresaById(empresaId.value)
    empresaNome.value = empresa.nome
  }
  getEmpresaNome()

  return {
    empresaNome,
  }
}
